import { useSelector } from "react-redux";
import { format, toZonedTime, fromZonedTime } from "date-fns-tz";

const useDateTime = () => {
  const { timezone } = useSelector((state) => state.login);

  const formatDateTime = ({ date = new Date(), dateformat = "" }) => {
    const zoneDate = toZonedTime(new Date(date), timezone);
    if (!date) return "";
    if (dateformat) {
      return format(zoneDate, dateformat, { timeZone: timezone });
    }
    return zoneDate;
  };

  const dateTimeToTimezone = ({ date = new Date() }) => {
    if (!date) return "";
    const zonefromDate = fromZonedTime(date, timezone);
    return zonefromDate;
  };

  return { formatDateTime, dateTimeToTimezone };
};

export default useDateTime;
